import { FC } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import LeftAligned8Pics from '@/slices/IntroMediaGrid/variants/LeftAligned8Pics';
import DefaultVariation from '@/slices/IntroMediaGrid/variants/DefaultVariation';

export type IntroMediaGridProps =
  SliceComponentProps<Content.IntroMediaGridSlice>;

const IntroMediaGrid: FC<IntroMediaGridProps> = ({ slice }) => {
  switch (slice.variation) {
    case 'leftAligned8Pics':
      return <LeftAligned8Pics slice={slice} />;
    case 'default':
    default:
      return <DefaultVariation slice={slice} />;
  }
};

export default IntroMediaGrid;
